/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Experience_Never_HintInputs */

const en_us2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan starts by teaching the movements`)
};

const pt_br2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano começa ensinando os movimentos`)
};

const es_419_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan empieza enseñando los movimientos`)
};

const pt_pt2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano começa por ensinar os movimentos`)
};

const fr_fr2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme commence par t'apprendre les mouvements`)
};

const de_de2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan beginnt damit, die Bewegungen zu lernen`)
};

const it_it2_profile_editors_experience_never_hint = /** @type {(inputs: Profile_Editors_Experience_Never_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda inizia insegnando i movimenti`)
};

/**
* | output |
* | --- |
* | "The plan starts by teaching the movements" |
*
* @param {Profile_Editors_Experience_Never_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_experience_never_hint = /** @type {((inputs?: Profile_Editors_Experience_Never_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Experience_Never_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_experience_never_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_experience_never_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_experience_never_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_experience_never_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_experience_never_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_experience_never_hint(inputs)
	return en_us2_profile_editors_experience_never_hint(inputs)
});
export { profile_editors_experience_never_hint as "profile-editors.experience_never_hint" }